<template>
  <div class="prevent-select unit-graph-page">
    <div class="mb-2 p-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <b-row>
      <b-col :md="isRightLibraryPanelHidden ? '12' : '8'">
        <span class="float-right text-primary hand" v-if="isRightLibraryPanelHidden" @click="toggleRightLibraryPanel">
          <i class="bx bx-show "></i>
          {{ $t("process.show-library") }}
        </span>

        <h2>{{ $t("unit.department-based-organizational-units", { name: department ? this.$options.filters.translate(department.name) : "" }) }}</h2>
        <content-loading v-if="loading"></content-loading>
        <flowy :nodes="nodes" :beforeMove="beforeMove" :beforeAdd="beforeAdd" @add="add" @move="move" @remove="remove" @drag-start="onDragStart"></flowy>
      </b-col>

      <b-col md="4" v-show="!isRightLibraryPanelHidden" class="border-left">
        <b-row>
          <b-col md="12">
            <span class="float-right text-primary hand " v-if="!isRightLibraryPanelHidden" @click="toggleRightLibraryPanel">
              <i class="bx bx-show "></i>
              {{ $t("common.hide") }}
            </span>
          </b-col>
        </b-row>
        <simplebar style="z-index:9000; max-height:800px; min-width: 400px;">
          <div>
            <b-tabs class="text-left badge font-size-11 hand " v-model="index">
              <!-- Sekmentasyon Başlangıcı -->

              <b-tab class="secondary" :title="$t('process.text')" id="sidebar-process" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                <div class="mt-4">
                  <h3><i class="mdi mdi-storefront-outline"></i> {{ $t("process.plural") }}</h3>

                  <div class="app-search d-none d-lg-block pt-0">
                    <div class="position-relative">
                      <input id="search-process" v-model="processLibraryRequestSearch" type="text" class="form-control bg-white" placeholder="Ara..." />
                      <span class="bx bx-search-alt"></span>
                    </div>
                  </div>
                  <flowy-new-block
                    v-for="(block, index) in processBlocks"
                    :key="block.preview.title + index"
                    class="q-mr-md"
                    @drag-start="onDragStartNewBlock"
                    @drag-stop="onDragStopNewBlock"
                  >
                    <template v-slot:preview>
                      <graph-block :title="block.preview.title" :description="block.preview.description">
                        <i v-if="block.preview.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                        <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
                      </graph-block>
                    </template>
                    <template v-slot:node="{}">
                      <graph-node
                        :title="block.node.title"
                        :description="block.node.description"
                        :custom-attribute="block.node.canBeAdded"
                        :entity="block.node.entity"
                        type="Process"
                      />
                    </template>
                  </flowy-new-block>

                  <div v-if="processLibraryPagination" class="row">
                    <div class="col">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="processLibraryRequestPage"
                          :total-rows="processLibraryPagination.totalDocs"
                          :per-page="processLibraryPagination.limit"
                          limit="10"
                          size="sm"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab class="text-secondary" :title="$t('process.new')" id="sidebar-new-process" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                <div class="mt-3" style="width:400px; min-height: 400px;" v-if="!editedEntity || !editedEntity._id">
                  <ProcessForm :hide-library="true" @onProcessSave="fetchProcessLibraryItems" />
                </div>
                <div class="mt-3" style="width:400px;" v-else>
                  <DepartmentProcessForm @onSave="fetchProcessLibraryItems" :reloadAfterSave="true" :hide-library="true" />
                </div>
              </b-tab>

              <!-- <recommendation-items
                v-if="department"
                :id="department._id"
                :draggable="false"
                level="process"
                libraryScopedState="process"
                organizationScopedState="organizationDepartmentProcess"
              /> -->

              <!-- <b-tab
                v-if="recommendationBlocks.length > 0"
                class="badge-lg text-secondary"
                :title="$t('common.recommendations')"
                id="sidebar-recomendations"
                :icon="'mdi mdi-plus'"
                @hidden="rightPanelClosed"
              >
                <div class="mt-4" style="width:400px;">
                  <h3><i class="mdi mdi-storefront-outline"></i> {{ $t("process.recommendations") }}</h3>

                  <flowy-new-block v-for="(block, index) in recommendationBlocks" :key="index" class="q-mr-md" @drag-start="onDragStartNewBlock" @drag-stop="onDragStopNewBlock">
                    <template v-slot:preview>
                      <graph-block :title="block.preview.title" :description="block.preview.description">
                        <i v-if="block.preview.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                        <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
                      </graph-block>
                    </template>
                    <template v-slot:node="{}">
                      <graph-node
                        :title="block.node.title"
                        :description="block.node.description"
                        :custom-attribute="block.node.canBeAdded"
                        :entity="block.node.entity"
                        type="Process"
                      />
                    </template>
                  </flowy-new-block>
                </div>
              </b-tab> -->
            </b-tabs>
          </div>
        </simplebar>
      </b-col>
    </b-row>
  </div>
</template>

<script>
//import RecommendationItems from "@cc/recommendation-items";
import Simplebar from "simplebar-vue";
import DepartmentProcessForm from "../department-process/organization-department-process-form";
// import RecommendationBoxes from "../entity/component/recommendation-boxes.vue";
import ProcessForm from "../process/organization-process-form.vue";
import Form from "./organization-unit-form";

export default {
  components: {
    Form,
    ProcessForm,
    DepartmentProcessForm,
    Simplebar,
    // RecommendationBoxes, RecommendationItems
  },
  data() {
    return {
      holder: [],
      loading: false,
      dragging: false,
      nodes: [],
      isRightLibraryPanelHidden: true,
      index: 0,
      showRecommendationBoxes: true,
      libraryScopedState: "process",
    };
  },

  computed: {
    department() {
      return this.$store.getters["organizationDepartment/selectedEntity"];
    },
    organization() {
      return this.$store.getters["organization/selected"];
    },
    editedEntity() {
      return this.$store.getters["organizationDepartmentProcess/editedEntity"];
    },

    processBlocks() {
      const pagination = this.$store.getters[`process/pagination`];
      if (!pagination) return [];

      return pagination.docs.map((i) => ({
        preview: {
          ...i,
          title: this.$options.filters.translate(i.name),
        },
        node: {
          entity: i,
          title: this.$options.filters.translate(i.name),
          description: "",
        },
      }));
    },

    recommendationBlocks() {
      const pagination = this.$store.getters[`${this.libraryScopedState}/recommendations`];
      if (!pagination) return [];

      return pagination.docs.map((i) => ({
        preview: {
          ...i,
          title: this.$options.filters.translate(i.name),
        },
        node: {
          entity: i,
          title: this.$options.filters.translate(i.name),
          description: "",
        },
      }));
    },

    isLibraryLoading() {
      return this.$store.getters[`unit/isLoading`];
    },

    processLibraryPagination() {
      return this.$store.getters[`process/pagination`];
    },
    isProcessLibraryLoading() {
      return this.$store.getters[`process/isLoading`];
    },
    processLibraryRequest() {
      return this.$store.state.process.request;
    },

    processLibraryRequestPage: {
      get() {
        return this.$store.state.process.request.options.page;
      },
      set(value) {
        this.$store.commit("process/request", {
          ...this.$store.state.process.request,
          options: {
            ...this.$store.state.process.request.options,
            page: value,
          },
        });
        this.fetchProcessLibraryItems();
      },
    },
    processLibraryRequestSearch: {
      get() {
        return this.$store.state.process.request.query.name.value;
      },
      set(value) {
        this.$store.commit("process/request", {
          ...this.$store.state.process.request,
          query: {
            name: { value },
          },
        });
        this.fetchProcessLibraryItems();
      },
    },
  },

  watch: {
    processBlocks: {
      deep: true,
      handler() {
        this.$forceUpdate(); //!important for rerender draggable items
      },
    },
  },

  mounted() {
    this.fetchLibraryItems();
    this.fetchProcessLibraryItems();
    this.loadNodes();

    this.$root.$on("edit", this.edit);
  },
  methods: {
    goBack() {
      this.$router.push(`/organization/unit-hierarchy`);
    },
    toggleRightLibraryPanel() {
      this.isRightLibraryPanelHidden = !this.isRightLibraryPanelHidden;
    },

    edit(node) {
      this.isRightLibraryPanelHidden = false;

      this.index = 1;
      this.$store.commit("organizationDepartmentProcess/editedEntity", node.entity);
    },

    rightPanelClosed() {
      this.$store.commit("organizationUnit/editedEntity", null);
      this.loadNodes();
      this.$store.dispatch("organizationDepartment/resetForm");
    },

    fetchLibraryItems() {
      this.$store.dispatch(`unit/paginate`, this.libraryRequest);
      this.loadNodes();
    },

    fetchProcessLibraryItems() {
      this.$store.dispatch(`process/paginate`, this.processLibraryRequest);
      this.loadNodes();
    },

    async loadNodes() {
      this.loading = true;
      const organization = this.$store.getters[`organization/selected`];
      const id = this.$route.params.id;

      const response = await this.$store.dispatch(`organizationDepartment/findById`, id);
      const department = response.data;

      const { data } = await this.$store.dispatch("organizationUnit/processGraph", id);
      const items = [
        {
          id: organization._id,
          parentId: -1,
          nodeComponent: "graph-node",
          icon: "bx bxs-school",
          root: true,
          type: "Organization",
          data: {
            text: this.$options.filters.translate(organization.name),
            title: this.$options.filters.translate(organization.name),
            description: null,
          },
        },

        {
          id: department._id,
          parentId: organization._id,
          nodeComponent: "graph-node",
          icon: "bx bxs-school",
          type: "Department",
          root: true,
          data: {
            text: this.$options.filters.translate(department.name),
            title: this.$options.filters.translate(department.name),
            description: null,
          },
        },

        ...data.map((i) => ({
          id: i._id,
          parentId: i.parentId,
          nodeComponent: "graph-node",
          icon: i.type == "Unit" ? "mdi mdi-office-building" : "mdi mdi-storefront-outline",
          type: i.type,
          data: {
            text: this.$options.filters.translate(i.name),
            title: this.$options.filters.translate(i.name),
            description: null,
          },
          entity: i,
        })),
      ];

      this.nodes = items;
      this.loading = false;
    },

    //
    onDragStartNewBlock(event) {
      // contains all the props and attributes passed to graph-node
      const { props } = event;
      this.newDraggingBlock = props;
    },
    onDragStopNewBlock(event) {
      this.newDraggingBlock = null;
    },
    // REQUIRED
    beforeMove({ to, from }) {
      // called before moving node (during drag and after drag)
      // indicator will turn red when we return false
      // from is null when we're not dragging from the current node tree
      if (to && to.parentId == -1) {
        return false;
      }
      // we cannot drag upper parent nodes in this demo
      if (from && from.parentId === -1) {
        return false;
      }
      if (from && from.parentId === this.organization._id) {
        return false;
      }

      if (from === null) {
        // we're adding a new node (not moving an existing one)
        // we've passed this attribute to the graph-node
        if (this.newDraggingBlock["custom-attribute"] === false) {
          return false;
        }
        if (to.type == "Process") {
          return false;
        }
      }
      if (from && from.parentId == to.id) {
        return false;
      }
      if (from && from.parentId == to.parentId) {
        return false;
      }

      let parentNode = this.nodes.find((n) => n.id == to.parentId);
      let i = 0;
      while (parentNode) {
        if (parentNode.id == from?.id) {
          return false;
        }
        parentNode = this.nodes.find((n) => n.id == parentNode.parentId);

        if (i++ > 40) return false;
      }

      return true;
    },
    // REQUIRED
    beforeAdd({ to }) {
      // called before moving node (during drag and after drag)
      // indicator will turn red when we return false
      // from is null when we're not dragging from the current node tree

      // we've passed this attribute to the graph-node
      if (this.newDraggingBlock["custom-attribute"] === false) {
        return false;
      }
      return true;
    },
    randomInteger() {
      return Math.floor(Math.random() * 10000) + 1;
    },
    generateId(nodes) {
      let id = this.randomInteger();
      // _.find is a lodash function
      while (_.find(nodes, { id }) !== undefined) {
        id = this.randomInteger();
      }
      return id;
    },
    addNode(_event) {
      const id = this.generateId();
      this.nodes.push({
        ..._event.node,
        id,
      });
    },
    async remove(event) {
      const id = event.node.entity._id;
      const name = event.node.entity.name;

      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartmentProcess/delete", id);

        this.loadNodes();

        this.$toast.success("'" + this.$options.filters.translate(name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(name) + "' Silinemedi" });
      }
    },
    async move(event) {
      const item = event.dragged.entity;
      const parentId = this.organization._id == event.to.id ? null : event.to.id;
      item.parent = parentId ? { _id: parentId } : null;
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("OrganizationDepartmentProces/save", {
          ...item,
          unit: item.parent,
        });

        this.loadNodes();
        this.$toast.success("Başarılı");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async add(event) {
      const libraryItem = event.node.data.entity;
      const parentId = this.organization._id == event.node.parentId ? null : event.node.parentId;
      if (this.organization._id == event.node.parentId) {
        return;
      }

      if (this.nodes.filter((i) => i.type == "Process").some((p) => p.id == event.node.parentId)) {
        return;
      }
      try {
        if (event.node.data.type == "Process") {
          await this.$store.dispatch(`organizationDepartmentProcess/addFromLibrary`, {
            libraryItem,
            department: parentId,
          });
        }

        this.$toast.success("'" + this.$options.filters.translate(libraryItem.name) + "' Eklendi");
        this.loadNodes();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    onDragStart(event) {
      this.dragging = true;
    },

    async paginate() {
      await this.$store.dispatch("organizationDepartment/paginate", this.request);
    },
  },
};
</script>

<style lang="scss">
.prevent-select * {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

.flowy-block.draggable-mirror {
  opacity: 0.6;
}

$borderTextColor1: #ff7c48;
$bgColor1: #ffeee8;

$borderTextColor2: #32c753;
$bgColor2: #e8ffed;

$borderTextColor3: #c645ff;
$bgColor3: #f8e8ff;

$borderTextColor4: #4dd4ff;
$bgColor4: #e8f4ff;

.flowy-drag-handle {
  .card {
    border-radius: 12px;
    overflow: hidden;
  }

  .card-body {
    text-align: left;
  }

  h6 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.3rem;
    font-size: 15px !important;
    text-align: center;

    i {
      font-size: 22px !important;
    }
  }

  &.level1 {
    .card {
      border: 2px solid $borderTextColor1 !important;
    }

    .card-body {
      background-color: $bgColor1 !important;
    }

    h6 {
      color: $borderTextColor1 !important;
    }
  }

  &.level2 {
    .card {
      border: 2px solid $borderTextColor2 !important;
    }

    .card-body {
      background-color: $bgColor2 !important;
    }

    h6 {
      color: $borderTextColor2 !important;
    }
  }

  &.level3 {
    .card {
      border: 2px solid $borderTextColor3 !important;
    }

    .card-body {
      background-color: $bgColor3 !important;
    }

    h6 {
      color: $borderTextColor3 !important;
    }
  }

  &.level4 {
    .card {
      border: 2px solid $borderTextColor4 !important;
    }

    .card-body {
      background-color: $bgColor4 !important;
    }

    h6 {
      color: $borderTextColor4 !important;
    }
  }
}

#search-process {
  color: black;
}

#search-unit {
  color: black;
}
</style>
